export default __webpack_public_path__ + "static/media/KTB.2d57eaf9.png";